import React, { useState, useEffect } from 'react';
import { RemoveSearchIcon, SearchBarIcon } from '../../../components/common/SvgIcon';

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(query);
    }, 500);

    return () => clearTimeout(timer);
  }, [query]);

  return (
    <div className="relative mb-6 w-[448px]">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <SearchBarIcon />
      </div>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search by ID or title..."
        className="w-[448px] h-11 !bg-[#FAFAFA] !pl-10 pr-2 py-3 border !border-[#E4E4E7] rounded-xl focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none"
      />
      {query && (
        <button
          onClick={() => setQuery('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
        >
          <RemoveSearchIcon />
        </button>
      )}
    </div>
  );
};

export default SearchBar;